import React from 'react';
import moment from 'moment';
import ContentTabs from '../../../core/components/ContentTabs';
import Photos from '../../../core/components/Photos';
import Items from '../../expenseDetail/components/Items';

const PurchaseOrderDrawerContent = ({ purchaseOrder, addFile, deleteFile, showDialog, intl }) => {
  return (
    <div className="drawer-details">
      {/* Basic Information */}
      <div className="drawer-section">
        <h4 className="drawer-section-title">Basic Information</h4>
        <div className="drawer-grid">
          <div className="drawer-field">
            <strong>PO Number:</strong> {purchaseOrder.orderNumber}
          </div>
          <div className="drawer-field">
            <strong>Location:</strong> {purchaseOrder.siteName}
          </div>
          <div className="drawer-field">
            <strong>Category:</strong> {purchaseOrder.categoryName || purchaseOrder.category?.name}
          </div>
          <div className="drawer-field">
            <strong>Vendor:</strong> {purchaseOrder.vendorName || purchaseOrder.vendor?.name}
          </div>
          {purchaseOrder.orderDate && (
            <div className="drawer-field">
              <strong>Order Date:</strong> {moment(purchaseOrder.orderDate).format('MM/DD/YYYY')}
            </div>
          )}
          {purchaseOrder.receivedAt && (
            <div className="drawer-field">
              <strong>Received At:</strong>{' '}
              {moment(purchaseOrder.receivedAt).format('MM/DD/YYYY h:mm A')}
            </div>
          )}
          <div className="drawer-field">
            <strong>Status:</strong> {purchaseOrder.receivedAt ? 'Received' : 'Open'}
          </div>
          {purchaseOrder.trackingNumber && (
            <div className="drawer-field">
              <strong>Tracking Number:</strong>{' '}
              <a
                className="drawer-link"
                href={`https://www.google.com/search?q=${purchaseOrder.trackingNumber}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {purchaseOrder.trackingNumber}
              </a>
            </div>
          )}
        </div>
      </div>

      {/* Financial Details */}
      <div className="drawer-section">
        <h4 className="drawer-section-title">Financial Details</h4>
        <div className="drawer-grid">
          {purchaseOrder.subTotal !== undefined && purchaseOrder.subTotal !== null && (
            <div className="drawer-field">
              <strong>Subtotal:</strong> $
              {Number(purchaseOrder.subTotal).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </div>
          )}
          {purchaseOrder.taxAmount !== undefined && purchaseOrder.taxAmount !== null && (
            <div className="drawer-field">
              <strong>Tax:</strong> $
              {Number(purchaseOrder.taxAmount).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </div>
          )}
          {purchaseOrder.shippingAmount !== undefined && purchaseOrder.shippingAmount !== null && (
            <div className="drawer-field">
              <strong>Shipping:</strong> $
              {Number(purchaseOrder.shippingAmount).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </div>
          )}
          {purchaseOrder.discount !== undefined && purchaseOrder.discount !== null && (
            <div className="drawer-field">
              <strong>Discount:</strong> $
              {Number(purchaseOrder.discount).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </div>
          )}
          <div className="drawer-field">
            <strong>Total:</strong> $
            {Number(purchaseOrder.total).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </div>
        </div>
      </div>

      {/* Tabs Section */}
      <ContentTabs
        components={{
          Memo: <div>{purchaseOrder.memo}</div>,
          Items: <Items data={purchaseOrder.items || []} />,
          Photos: (
            <Photos
              photos={purchaseOrder.files ? purchaseOrder.files.filter((f) => !f.archivedAt) : []}
              addFile={(formData) => {
                addFile({
                  siteId: purchaseOrder.siteId,
                  purchaseOrderId: purchaseOrder.id,
                  file: formData,
                });
              }}
              deleteFile={(file) => {
                const confirmProps = {
                  onReady: () =>
                    deleteFile({
                      fileId: file.id,
                      purchaseOrderId: purchaseOrder.id,
                    }),
                  text: intl.formatMessage(
                    { id: 'confirmFileArchive' },
                    { fileName: file.originalName }
                  ),
                  title: intl.formatMessage({ id: 'archiveFile' }),
                };
                showDialog('CONFIRM_DIALOG', confirmProps);
              }}
            />
          ),
        }}
        scrollable={true}
      />
    </div>
  );
};

export default PurchaseOrderDrawerContent;
